import giftvoucherprint from "../../../../assets/images/GV-02.png";
import MainButton from "../../../../components/button/mainButton";
import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import HeaderBar from "../../../../components/header/headerBar";

const GiftVoucherPrint = () => {
  return (
    <div>
      <HeaderBar title="PRINT GIFT VOUCHER" btnBack={true} />
      <div>
        <div className="justify-center mt-10">
          <img
            src={giftvoucherprint}
            style={{ borderRadius: "4px", width: "992px", height: "650px" }}
          ></img>
        </div>
        <div className="justify-center mt-10">
          <MainButton className="mg-10" title="Print">
            <Icon path={mdiPrinter} size="20" color="#ffff" />
          </MainButton>
        </div>
      </div>
    </div>
  );
};
export default GiftVoucherPrint;
